import { Box, HStack, Stack } from '@chakra-ui/react';
import { Bleed, Button, Card, TextField } from '@main/complykit';
import { Table, toast } from '@main/ui';
import { useState } from 'react';

import { useBackofficeSelector } from '../../hooks/redux-toolkit-hooks';
import { useInsertSubOrgMutation } from './InsertSubOrg.admin.generated';
import { getOrganizationsMap } from './slice';
import { useOrganizationsTableColumns } from './use-org-table-columns';

const tableId = 'sub-organizations';

export const SubOrganizationsTab = ({ orgId }: { orgId: string }) => {
  const [subOrgName, setSubOrgName] = useState('');
  const { columns, onRowClick } = useOrganizationsTableColumns();

  const [createSubOrg, { isLoading: isCreatingSubOrg }] = useInsertSubOrgMutation();
  const organization = useBackofficeSelector(getOrganizationsMap)?.[orgId];

  const handleCreateSubOrg = async () => {
    if (subOrgName.trim() && orgId) {
      try {
        await createSubOrg({
          name: subOrgName.trim(),
          parent_organization_id: orgId,
        }).unwrap();

        setSubOrgName('');

        toast({
          id: 'createSubOrg',
          title: 'Sub organization successfully created',
          status: 'success',
          duration: 5000,
          isClosable: true,
        });
      } catch {
        toast({
          id: 'createSubOrg',
          title: 'Unable to create sub organization',
          status: 'error',
          duration: 5000,
          isClosable: true,
        });
      }
    } else {
      toast({
        id: 'createSubOrg',
        title: 'sub org name is missing!',
        status: 'error',
        duration: 5000,
        isClosable: true,
      });
    }
  };

  return (
    <Stack spacing={10}>
      <Card>
        <Bleed>
          <Table
            id={tableId}
            entity="organization"
            data={organization?.subOrgs || []}
            columns={columns}
            itemName={{
              singular: 'sub organization',
              plural: 'sub organizations',
            }}
            onRowClick={onRowClick}
          />
        </Bleed>
      </Card>
      <HStack spacing={3} alignItems="end">
        <Box w="55">
          <TextField
            label="Create new sub org"
            placeholder="Enter sub org name"
            value={subOrgName}
            onChange={setSubOrgName}
          />
        </Box>
        <Button isPending={isCreatingSubOrg} onPress={() => void handleCreateSubOrg()}>
          Create
        </Button>
      </HStack>
    </Stack>
  );
};
